import React, { Component } from 'react';

import { MSection, Title } from 'components/misc';
import {
    Row, Col
} from 'design-react-kit';
import { Helmet } from 'react-helmet';


export class TfaIndireEsteroTriennalisti extends Component {

    render() {
        const title = 'Percorsi INDIRE ';
        return (
            <>
                <Helmet>
                    <title>{title}</title>
                    <meta property="og:title" content={title} />
                </Helmet>
                <MSection>
                    <Row>
                        <Col>
                            <Title>{title}</Title>
                            <Row>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <div className="swiper-slide my-2">
                                        <div className="programme-card">
                                            <a className="programme-card__link" href="../adesioni-tfa-sostegno-triennalisti">
                                                <div className="programme-card__header">
                                                    <img className="programme-card__img" alt="Percorsi INDIRE Corsi per docenti con 3 anni sul sostegno" src="/img/courses/new/sostegno_triennalisti.jpg" />
                                                </div>
                                                <div className="programme-card__body">
                                                    <h4 className="programme-card__title">Percorsi INDIRE<br />Corsi per docenti con 3 anni sul sostegno</h4>
                                                    <h6 className="text-red  text-highlights">Scadenza: 19 Maggio 2026 ore 15:00</h6>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <div className="swiper-slide my-2">
                                        <div className="programme-card">
                                            <a className="programme-card__link" href="../adesioni-tfa-sostegno-estero">
                                                <div className="programme-card__header">
                                                    <img className="programme-card__img" alt="Percorsi INDIRE Corsi per docenti con abilitazione estera" src="/img/courses/new/sostegno_estero.jpg" />
                                                </div>
                                                <div className="programme-card__body">
                                                    <h4 className="programme-card__title">Percorsi INDIRE<br />Corsi per docenti con abilitazione estera</h4>
                                                    <h6 className="text-red  text-highlights">Scadenza: 19 Maggio 2026 ore 15:00</h6>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </MSection>
            </>);
    }
}